import React from "react";

interface WatcherFormStepProps {
  children: React.ReactNode;
}

export default function WatcherFormStep({ children }: WatcherFormStepProps) {
  return <>{children}</>;
}
